// import logo from './img.png'
import numWords from 'num-words'
import { getConfig } from '../../resources/configSettings';

/** Invoice Template */
const invoicePatternGST = ({ companyName, companyAddress, companyContact, gst, customerName, customerGST, customerDetails, customerContact, invoiceNo, billDate, products, subtotalAmt, gstTotal, totalAmt, saletype }) => {
    let Config = getConfig();

    return `
<!DOCTYPE html >
<html >

<head>
    <meta http-equiv='Content-Type' content='text/html; charset=UTF-8' />
	<link rel='stylesheet' type='text/css' href='invoice.css' />
	
	<title>Invoice - ${invoiceNo}</title>
</head>  
<style> 
* {
    margin: 0;
    padding: 0;
}

body {
    font: 14px/1.4 Georgia, serif;
}

#page-wrap {
    width: 725px;
    margin: 0 auto;
}

textarea {
    border: 0;
    font: 14px Georgia, Serif;
    overflow: hidden;
    resize: none;
}

table {
    border-collapse: collapse;
}

table td,
table th {
    border: 1px solid black;
    padding: 5px;
}

#hiderow,
.delete {
    display: none;
}

#header {
    
    width: 100%;
    margin: 20px 0;
    background: #222;
    text-align: center;
    color: white;
    font: bold 15px Helvetica, Sans-Serif;
    text-decoration: uppercase;
    letter-spacing: 20px;
    padding: 8px 0px;
}

#identity {
    text-align : center;
}

#company {
    display: inline-block;
    width: 250px;
    height: 100px;
}



#customer {
    overflow: hidden;
}

#logo {
    text-align: right;
    float: right;
    position: relative;
    margin-top: 25px;
    border: 1px solid #fff;
    max-width: 540px;
    max-height: 100px;
    overflow: hidden;
}

#customer-title {
    font-size: 20px;
    font-weight: bold;
    
}

#meta {
    margin-top: 1px;
    width: 200px;
    float: right;
    margin-bottom: 10px;
}

#meta td {
    text-align: right;
}

#meta td.meta-head {
    text-align: left;
    background: #eee;
}

#items {
    clear: both;
    width: 100%;
    margin: 30px 0 0 0;
    border: 1px solid black;
    
}

#items th {
    background: #eee;
}

#items textarea {
    width: 80px;
    height: 50px;
}

#items tr.item-row td {
    padding-bottom: 5px;
    text-align: center;
    border: 0;
    vertical-align: top;
}

#items td.description {
    width: 300px;
}

#items td.item-name {
    width: 200px;
}

#items td.sno {
    width: 2rem;
}

#items td.description textarea,
#items td.item-name textarea {
    width: 100%;
}

#items td.total-line {
    border-right: 0;
    text-align: right;
}

#items td.total-value {
    border-left: 0;
    // padding: 10px;
}

#items td.total-value  {
    background: none;
    // text-align: center;
}

#items td.balance {
    background: #eee;
}

#items td.blank {
    border: 0;
}
#items td.end {
    border-top: 1px solid black;
    border-bottom: 1px solid black;
}

#terms {
    text-align: center;
    margin: 20px 0 0 0;
}

#signature {
    text-align: right;
    padding-top: 5px;
}

#sign {
    padding-top: 45px;
}

#terms h5 {
    text-transform: uppercase;
    font: 13px Helvetica, Sans-Serif;
    letter-spacing: 10px;
    border-bottom: 1px solid black;
    padding: 0 0 8px 0;
    margin: 0 0 8px 0;
}

#terms  {
    width: 100%;
    text-align: center;
}

thead.itembox{
    display: block;
    height: 400px;
}

.text-capital {
    text-align: center;
    text-justify: auto;
    text-transform: capitalize;

}

.start{
    border-top: 1px solid black;
    border-bottom: 1px solid black;
}


</style>
<body>

	<div id="page-wrap">

		<h5 id="header">INVOICE</h5>
		
		<div id="identity">
            <div id="company">
                <h3> ${companyName} </h3>
                <p> ${companyAddress} </p>
                <p> ${companyContact} </p>
                ${Config.gst.enabled && gst ? (`<p><b>GSTIN </b>${gst}</p>`) : ('')}
            </div>
        </div>
        
        
			
		<div id="customer">
            <p>Bill To :</p>
            <p id="customer-title">${customerName}</p>
            <p>${customerDetails}</p>
            <p>${customerContact}</p>
            ${customerGST ? (`<p><b>GSTIN</b> ${customerGST}</p>`) : ('')}
        </div>
        <table id="meta">
                <tr>
                    <td class="meta-head">Invoice #</td>
                    <td><span>${invoiceNo}</span></td>
                </tr>
                <tr>

                    <td class="meta-head">Date</td>
                    <td><span id="date">${billDate}</span></td>
                </tr>

            </table>
		
		<table id="items">
		
          <thead>
            <tr>
            <th>#</th>
            <th>Name</th>
            <th>HSN</th>
            <th>Quantity</th>
            <th>Price</th>
            <th>Amount</th>
            ${saletype === 'intrastate' ? (`
            <th colspan='2'>CGST</th>
            <th colspan='2'>SGST</th>`) : ('')}
            ${saletype === 'interstate' ? (`
            <th colspan='2'>IGST</th>`) : ('')}
            <th>Total</th>
            </tr>
            <tr>
            <th colspan='6'></th>
            ${saletype === 'intrastate' ? (`
            <th>%</th>
            <th>Amt</th>`) : ('')}
            <th>%</th>
            <th>Amt</th>
            <th></th>
            </tr>
            
          </thead>
          <tbody>
          ${products.map((product, i) => {
        return `
                <tr class="item-row" key= ${product.id}>
                    <td className='sno'>${i + 1}.</td>
                    <td class="item-name">${product.name}</td>
                    <td>${product.hsn ? product.hsn : ''}</td>
                    <td>${product.quantity}</td>
                    <td>${(product.price).toFixed(2)}</td>
                    <td>${(product.amount).toFixed(2)}</td>    
            ${saletype === 'intrastate' ? (`
                    <td>${product.gstr / 2}</td>
                    <td>${(product.gstAmt / 2).toFixed(2)}</td>
                    <td>${product.gstr / 2}</td>
                    <td>${(product.gstAmt / 2).toFixed(2)}</td>`) : ('')}
            ${saletype === 'interstate' ? (`
                    <td>${product.gstr}</td>
                    <td>${(product.gstAmt).toFixed(2)}</td>`) : ('')}

                    
                    <td>${(product.total).toFixed(2)}</td>
		        </tr> `;
    })}
        
        ${products.length < 6 ? saletype === "intrastate" ? (`
        <tr class="item-row"><td colspan='11'></td></tr>
        <tr class="item-row"><td colspan='11'></td></tr>
        <tr class="item-row"><td colspan='11'></td></tr>
        <tr class="item-row"><td colspan='11'></td></tr>
        <tr class="item-row"><td colspan='11'></td></tr>
        <tr class="item-row"><td colspan='11'></td></tr>
        <tr class="item-row"><td colspan='11'></td></tr>`)
            : saletype === 'interstate' ? (`
        <tr class="item-row"><td colspan='9'></td></tr>
        <tr class="item-row"><td colspan='9'></td></tr>
        <tr class="item-row"><td colspan='9'></td></tr>
        <tr class="item-row"><td colspan='9'></td></tr>
        <tr class="item-row"><td colspan='9'></td></tr>
        <tr class="item-row"><td colspan='9'></td></tr>
        <tr class="item-row"><td colspan='9'></td></tr>`) : ('') : ('')}
            

		${saletype === 'intrastate' ? (

            `
        <tr class='item-row start'>
            <td colSpan="5" style='text-align : left' className="">Total :  </td>
            <td colSpan="1" className="">${(subtotalAmt).toFixed(2)}</td>
            <td colSpan="2" >${(gstTotal / 2).toFixed(2)}</td>
            <td colSpan="2" >${(gstTotal / 2).toFixed(2)}</td>
            <td colSpan="1" >${(totalAmt).toFixed(2)}</td>
        </tr >
         <tr className=''>
            <td colSpan="7" class="blank"> </td>
            <td colSpan="2" class="total-line">SubTotal : </td>
            <td colSpan="2" class="total-value"><span id="total">Rs. ${(subtotalAmt).toFixed(2)}</span></td>
        </tr >
        <tr className=''>
            <td colSpan="7" class="blank "></td>
            <td colSpan="2" class="total-line">CGST : </td>
            <td colSpan="2" class="total-value"><span id="total">Rs. ${(gstTotal / 2).toFixed(2)}</span></td>
        </tr>
        <tr className=''>
            <td colSpan="7" class="blank "></td>
            <td colSpan="2" class="total-line">SGST : </td>
            <td colSpan="2" class="total-value"><span id="total">Rs. ${(gstTotal / 2).toFixed(2)}</span></td>
        </tr>
        <tr className=''>
            <td colSpan="7" class="blank end text-capital">(in words) ${numWords(parseInt(totalAmt))} rupees only</td>
            <td colSpan="2" class="total-line">Total</td>
            <td colSpan="2" class="total-value"><span id="total">Rs. ${totalAmt.toFixed(2)}</span></td>
        </tr>`

        ) : ('')
        }
        ${saletype === 'interstate' ? (
            `
            <tr class='item-row start'>
            <td colSpan="5" style='text-align : left' className="">Total  </td>
            <td colSpan="1" className="">${(subtotalAmt).toFixed(2)}</td>
            <td colSpan="2" >${(gstTotal).toFixed(2)}</td>
            <td colSpan="1" >${(totalAmt).toFixed(2)}</td>
        </tr >
            <tr className=''>
            <td colSpan="5" class="blank start"> </td>
            <td colSpan="2" class="total-line">SubTotal :</td>
            <td colSpan="2" class="total-value"><span id="total">Rs. ${(subtotalAmt.toFixed(2))}</span></td>
        </tr >
        <tr className=''>
            <td colSpan="5" class="blank"></td>
            <td colSpan="2" class="total-line">IGST :</td>
            <td colSpan="2" class="total-value"><span id="total">Rs. ${(gstTotal).toFixed(2)}</span></td>
        </tr>
        <tr className=''>
            <td colSpan="5" class="blank end text-capital">(in words) ${numWords(parseInt(totalAmt))} rupees only</td>
            <td colSpan="2" class="total-line">Total :</td>
            <td colSpan="2" class="total-value"><span id="total">Rs. ${totalAmt.toFixed(2)}</span></td>
        </tr>`
        ) : ('')
        }
        
        
        </tbody>
        </table>
        
        <div id="signature">
        <p >For ${companyName}</p>
        <p id='sign'>Authorized Signature</p>
        </div>
		
		<div id="terms">
		  <h5>Terms</h5>
		  <span>All jurisdiction are subjected to district court.</span>
		</div>
	
	</div>
	
</body>

</html>
`;
}
export default invoicePatternGST;
